function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  fill: "#194C73",
  d: "M64.743,67.319l27.863,14.034L64.743,96.164v-6.642v-2.305h-2.305H4.684V75.38h57.754h2.305v-2.305V67.319  M62.438,63.577v9.498H2.379v16.447h60.06V100l35.183-18.701L62.438,63.577L62.438,63.577z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#009AD7",
  d: "M43.772,6.958l16.125,28.178H52.62h-3.408l-0.048,3.407c-0.179,12.653-5.148,24.684-13.994,33.876 c-8.052,8.367-18.361,13.33-29.336,14.193V75.466c19.574-2.66,30.802-15.252,32.535-36.595l0.303-3.736h-3.748h-7.276 L43.772,6.958 M43.772,0L21.689,38.591h13.236C33.224,59.538,22.376,70.794,2.379,72.359v17.845 c27.49,0,49.849-23.834,50.241-51.612h13.237L43.772,0L43.772,0z"
})));

var SvgRecognition = function SvgRecognition(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "recognition",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRecognition, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Recognition.c9905c7f.svg";
export { ForwardRef as ReactComponent };